import { decodeQueryString, modifyQueryParams } from 'rev-shared/util/Util.Service';

//If this was a redirect from /sso/consume, this param will be set.
export const isSsoConsume = decodeQueryString().sso === true;

if(isSsoConsume) {
	const url = modifyQueryParams(window.location.href, params => {
		delete params.sso;
		return params;
	});

	history.pushState({}, '', url);
}
